import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { upsertProduct } from "../thunks/upsertProduct";
import { setFetchState } from "../productsDataReducer";
import { Product } from "../types";

export const useProductUpsert = () => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		store => store.data.listing.products.fetchState
	);

	const dispatch = useDispatch();
	const dispatchUpsertRole = React.useCallback(
		(product: Product) => dispatch(upsertProduct(product)),
		[dispatch]
	);

	React.useEffect(() => {
		dispatch(setFetchState({ type: "not-started" }))
	}, [dispatch])

	return [fetchState, dispatchUpsertRole] as [typeof fetchState, typeof dispatchUpsertRole]
};
